/**
 * Created by jgolebiewski on 19.10.2015.
 */
common.factory('provincesResource', ['$resource', function ($resource) {
    return $resource(appRoot + '/common/resources/provinces.json');
}]);